import { ReactComponent as Icon } from "../assets/icons/arrow-forward.svg";

export default function Button({ config }) {
  if (config.redirect.includes("[COUPON]")) {
    const urlObj = new URL(window.location.href);
    const coupon = urlObj.searchParams.get("coupon");
    if(coupon){
      const target = new URL(config.redirect.replace('[COUPON]', ''))
      target.searchParams.set('coupon', coupon)
      config.redirect = target.toString()
    } else {
      config.redirect = config.redirect.replace('[COUPON]', '')
    }
  }

  return (
    <div
      className={"button-box " + config.variant}
      style={{ ...(config.style || {}) }}
    >
      <a href={config.redirect} className={"button " + config.variant}>
        <p>{config.text}</p>
        <Icon />
      </a>
    </div>
  );
}
